/**
 * LaunchDarkly flag values for METRC_RECEIPT_AUDIT_V2_ACCESS
 * 0 = Off (feature disabled)
 * 1 = On for superusers only (view and actions available)
 * 2 = On for all users but view only (no bulk actions shown)
 * 3 = On for all users (view and bulk actions available)
 */
export enum ReceiptAuditV2FlagValue {
  OFF = 0,
  SUPERUSER_ONLY = 1,
  ALL_USERS_VIEW_ONLY = 2,
  ALL_USERS_WITH_ACTIONS = 3,
}

/**
 * Determines if the receipt audit v2 feature should be visible based on flag value and user permissions
 */
export function canViewReceiptAuditV2(flagValue: number | undefined, isSuperUser: boolean): boolean {
  if (!flagValue || flagValue === ReceiptAuditV2FlagValue.OFF) {
    return false;
  }
  if (flagValue === ReceiptAuditV2FlagValue.SUPERUSER_ONLY) {
    return isSuperUser;
  }
  // flagValue === 2 or 3 - all users can view
  return true;
}

/**
 * Determines if bulk actions should be shown based on flag value and user permissions
 */
export function canUseReceiptAuditV2Actions(flagValue: number | undefined, isSuperUser: boolean): boolean {
  if (!flagValue || flagValue === ReceiptAuditV2FlagValue.OFF) {
    return false;
  }
  // Superusers always have actions when feature is enabled
  if (isSuperUser) {
    return true;
  }
  if (flagValue === ReceiptAuditV2FlagValue.SUPERUSER_ONLY) {
    return false; // Non-superusers can't use actions when flag is 1
  }
  if (flagValue === ReceiptAuditV2FlagValue.ALL_USERS_VIEW_ONLY) {
    return false; // No actions for anyone (except superusers handled above)
  }
  // flagValue === 3 - all users can use actions
  return true;
}
